import { useRef, useEffect, useState } from "react"

import Head from "./components/Head"
import HeaderItau from "components/Header"
import Hero from "./Sections/Hero"
import Cards from "./Sections/Cards"
import Bankslip from "./Sections/Bankslip"
import Renegotiations from "./Sections/Renegotiations"
import Partners from "./Sections/Partners"
import Benefits from "./Sections/Benefits"
import Numbers from "./Sections/Numbers"
import Tips from "./Sections/Tips"
import Faq from "./Sections/Faq"
import PinnedButton from "./Sections/PinnedButton"
import { Footer } from "@mobi/ds"
import tracking from "./trackings"
import storage from "utils/storage"
import analytics from "@mobi/libraries/analytics"

import "./LandingDefault.scss"

const Landing = () => {
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const formRef = useRef(null)

  const checkIfFormIsOnViewport = () => {
    const form = formRef.current

    if (!form) return

    const pageScroll = document.documentElement.scrollTop
    const formHeightOffset = form?.offsetTop + form?.offsetHeight

    setIsButtonVisible(pageScroll > formHeightOffset)
  }

  useEffect(() => {
    tracking.pageView()
    document.addEventListener("scroll", checkIfFormIsOnViewport)

    const urlParams = new URLSearchParams(location.search)
    storage.session.setItem("mp_uuid", urlParams.get("mp_uuid"))
    storage.session.setItem("startSourceURL", location.href)
    storage.session.setItem("keepSessionLPfromRegister", true)
    storage.session.setItem(
      "mock_novos_limites",
      urlParams.get("mock_novos_limites")
    )
  }, [])

  return (
    <div className="landing">
      <Head />
      <HeaderItau />
      <Hero formRef={formRef} />
      <Cards />
      <Partners />
      <Renegotiations />
      <Benefits />
      <Bankslip />
      <Numbers />
      <Tips />
      <Faq />
      <PinnedButton isVisible={isButtonVisible} />
      <Footer />
    </div>
  )
}

export default Landing
